import React from 'react';
import './SizeGuide.scss';
import Collapse from '../Collapse/Collapse';

const sizeGuides = [
  {
    text: 'Lens Width',
    img: 'https://static.lenskart.com/owndays/img/pdp/size-guide-01.svg',
  },
  {
    text: 'Bridge Width',
    img: 'https://static.lenskart.com/owndays/img/pdp/size-guide-02.svg',
  },
  {
    text: 'Temple Length',
    img: 'https://static.lenskart.com/owndays/img/pdp/size-guide-03.svg',
  },
  {
    text: 'Lens Height',
    img: 'https://static.lenskart.com/owndays/img/pdp/size-guide-04.svg',
  },
];

function SizeGuide() {
  return (
    <div className="size-guide">
      <Collapse title="Size Guide">
        <p className="size-guide__text">
          Sizing details can be found on either the left or right temple (the arm at the side of the
          spectacle frame).
          <img
            alt=""
            loading="lazy"
            src="https://static.lenskart.com/owndays/img/pdp/size-guide-sample.webp"
          />
        </p>
        {sizeGuides && (
          <ul className="size-guide__list">
            {sizeGuides?.map(sizeGuide => (
              <li key={sizeGuide?.text}>
                <img alt={sizeGuide?.text} loading="lazy" src={sizeGuide?.img} />
              </li>
            ))}
          </ul>
        )}
      </Collapse>
    </div>
  );
}

export default SizeGuide;
